import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Button,
  styled,
  FormControl,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";
import ArticleEditor from "../manageStores/ArticleEditor";
import DescriptionIcon from "@mui/icons-material/Description";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";
import { useNavigate } from "react-router-dom";

const StyledCard = styled(Box)(({ theme }) => ({
  // تصميم خاص
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  height: "90%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

function Edit({ storeId, onClose, onSubmit }) {
  const [isLoading, setIsLoading] = useState(false);
  const [articleData, setArtcileData] = useState({
    title: "",
    description: "",
    slug: "",
    metaDescription: "",
    imageURL: "",
  });
  const navigate = useNavigate();

  const [imageFile, setImageFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const fetchCarData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}Article/Find/${storeId}`,
        );
        setArtcileData(response.data);
        setArtcileData({
          title: response.data.title || "",
          description: response.data.description || "",
          slug: response.data.slug || "",
          metaDescription: response.data.metaDescription || "",
          imageURL: response.data.imageURL || "",
        });
        setImageFile(response.data.imageURL);
        setPreviewImage(response.data.imageURL);
      } catch (error) {
        alert("Failed to load car data.");
      }
    };

    fetchCarData();
  }, [storeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setArtcileData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        setArtcileData((prevData) => ({
          ...prevData,
          imageURL: reader.result,
        }));
      };
      reader.readAsDataURL(file);
      setImageFile(file);
    } else {
      console.error("الملف غير صالح");
    }
    e.target.value = "";
  };

  const handleRemoveImage = () => {
    setArtcileData((prevData) => ({
      ...prevData,
      imageURL: "",
    }));
    setImageFile(null);
  };

  const handleDescriptionChange = (value) => {
    setArtcileData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const handleSubmit = async () => {
    if (
      !articleData.title ||
      !articleData.description ||
      !articleData.slug ||
      !articleData.metaDescription ||
      !imageFile
    ) {
      alert("يرجى ملء جميع الحقول.");
      return;
    }

    const token = localStorage.getItem("token");

    setIsLoading(true);

    const buildFormData = () => {
      const formData = new FormData();
      formData.append("title", articleData.title);
      formData.append("description", articleData.description);
      formData.append("slug", articleData.slug);
      formData.append("metaDescription", articleData.metaDescription);
      formData.append("imageURL", articleData.imageURL);
      formData.append("imageFile", imageFile || previewImage);
      return formData;
    };

    try {
      await axios.put(
        `${API_BASE_URL}Article/Update/${storeId}`,
        buildFormData(),
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      alert("تم تعديل المقال بنجاح");
      onSubmit();
      onClose();
    } catch (error) {
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();

          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          await axios.put(
            `${API_BASE_URL}Article/Update/${storeId}`,
            buildFormData(),
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          alert("تم تعديل المقال بنجاح");
          onSubmit();
          onClose();
        } catch (retryError) {
          alert("Retry failed: " + retryError.message);
        }
      } else {
        alert(
          "Error updating article: " + (error.response?.data || error.message),
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div>..جاري التحميل</div>;
  }

  return (
    <Modal
      dir="rtl"
      open={true}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <StyledCard>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                fontFamily: "'Changa', sans-serif",
              }}
            >
              <h3>تعديل المقال</h3>
            </div>
          </Box>
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>

          {/* تصميم العرض الجانبي للصورة والحقول */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            {/* الصورة على اليسار */}
            <Box
              sx={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* عرض الصورة أو النص الافتراضي */}
              <Box
                sx={{
                  width: 300,
                  height: 180,
                  marginTop: 2,
                  border: "1px solid #ccc",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#f5f5f5",
                  textAlign: "center",
                  borderRadius: 2,
                }}
              >
                {articleData.imageURL ? (
                  <img
                    src={articleData.imageURL}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Typography variant="body2">لا توجد صورة</Typography>
                )}
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "3%",
                  gap: "10px",
                }}
              >
                <Button variant="contained" component="label">
                  تحميل صورة
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>

                {/* زر إزالة الصورة */}
                {articleData.imageURL && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleRemoveImage} // استدعاء دالة إزالة الصورة هنا
                    //sx={{ mt: 2 }}
                  >
                    إزالة الصورة
                  </Button>
                )}
              </div>
            </Box>

            {/* الحقول على اليمين */}
            <Box sx={{ width: "65%" }}>
              <CardContent sx={{ textAlign: "right", mt: 1 }}>
                {/* حقول الإدخال */}
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="عنوان المقال"
                    value={articleData.title}
                    name="title"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocalGroceryStoreIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="رابط المقال"
                    value={articleData.slug}
                    disabled
                    name="slug"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LinkIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <TextField
                    placeholder="وصف الميتا"
                    value={articleData.metaDescription}
                    name="metaDescription"
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DescriptionIcon sx={{ color: "#1976d2" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>

                {/* محرر النصوص للوصف */}
                <FormControl fullWidth sx={{ marginBottom: 1 }}>
                  <ArticleEditor
                    value={articleData.description}
                    onChange={handleDescriptionChange}
                  />
                </FormControl>
              </CardContent>
            </Box>
          </Box>

          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              حفظ التعديلات
            </Button>
          </Box>
        </StyledCard>
      </Box>
    </Modal>
  );
}

export default Edit;
